import * as React from "react";
import {cx} from "emotion";

import "./meta-share-target-box.scss";

import {cs}          from "@Common/react/chain-services";
import {negateState} from "@Common/react/negate-state";
import {chain}       from "@Common/utils/fs";
import {upperCase1}  from "@Common/utils/strings";

import {SliderCheckbox} from "../../../../slider-checkbox/slider-checkbox";
import {Checkbox}       from "../../../common/design2/checkbox/checkbox";
import {AccountLine}    from "../common/account-line";
import {Header}         from "../common/header";

export const MetaShareTargetBox = (
    {
        login_url, account, unselected, fbUnselected, igUnselected, onRemoveAccount,
        igAvailable, isShared,
    }
) => cs(
    ["type", (_, next) => next(igAvailable ? "meta" : "facebook")],
    ({type}) => (
        <div
            className="meta-share-target-box-1js"
            xd-qa-type="card" xd-qa-name="Meta"
        >

            <div className={cx("box", {"has-content": !unselected.value})}>

                {Header({
                    icon: {
                        src: igAvailable ? "assets/meta-icon-dark.png" : "assets/facebook-icon-dark.png",
                        background: "white",
                    },
                    type, login_url,
                    unselected: account && unselected,
                })}

                {!unselected.value && (
                    <div className="content">
                        { !account ? (
                            <div className="action">
                                <a
                                    className={cx("link-btn", { "disabled": !login_url })}
                                    href={login_url}
                                    xd-qa-type={"link"}
                                    xd-qa-name={"Add Account Facebook"}
                                >
                                    {login_url ? "Add Account" : "Unavailable"}
                                </a>
                            </div>
                        ) : (
                            Account({
                                account, onRemoveAccount, login_url, fbUnselected, igUnselected,
                                type: "facebook",
                                igAvailable,
                            })
                        )}

                        {(isShared?.("instagram") || isShared?.("facebook")) && (
                            <div className="warning">
                                This event has been shared on {upperCase1(type)} before
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    ),
);

const Account = ({onRemoveAccount, account, login_url, fbUnselected, igUnselected, type, igAvailable}) => cs(
    ({}) => <>
        {AccountLine({onRemoveAccount, account, type})}

        <div className="fb-section">
            {igAvailable && account.pages && (
                <div className="fb-header">
                    <div className="title">
                        <a
                            className="logo" href={login_url}
                            xd-qa-type={"logo"}
                            xd-qa-name={upperCase1(type)}
                        >
                            <img
                                src="assets/facebook-icon-dark.png" alt="facebook"
                            />
                        </a>
                        <a
                            className="name" href={login_url}
                            xd-qa-type={"link"}
                            xd-qa-name={"Login " + upperCase1(type)}
                        >
                            Facebook
                        </a>
                    </div>
                    <div className="controls">
                        {fbUnselected && (
                            SliderCheckbox({
                                ...negateState(fbUnselected),
                                dark: true,
                                xdQaName: "Facebook",
                            })
                        )}
                    </div>
                </div>
            )}

            {!fbUnselected.value && account.pages && (
                <div className="pages">
                    {account.pages.map((page) => (
                        <div className="page" key={page.id}>
                            <div className="picture">
                                <img src={page.picture} alt={""}/>
                            </div>
                            <div
                                className="name"
                                xd-qa-type="label"
                                xd-qa-name={"Facebook Page " + page.name}
                            >
                                {page.name}
                            </div>
                            <div className="toggle">
                                {Checkbox({
                                    ...chain(
                                        negateState(page.unselectedPage),
                                        (_) => ({
                                            checked: _.value,
                                            onClick: () => _.onChange(!_.value),
                                        })
                                    ),
                                    color: "green",
                                    xdQaName: "Facebook Page " + page.name,
                                })}
                            </div>
                        </div>
                    ))}
                </div>
            )}
            {!account.pages && (
                <div className="missing-pages">
                    We could not access your Facebook page.
                    Please <a
                        className="remove"
                        onClick={onRemoveAccount}
                    >remove</a> your account and retry.
                </div>
            )}
        </div>

        {igAvailable && account.pages && (
            <div className="ig-section">
                <div className="ig-header">
                    <div className="title">
                        <a
                            className="logo"
                            href={login_url}
                            xd-qa-type="logo"
                            xd-qa-name="Instagram"
                        >
                            <img
                                src="assets/instagram-icon-light.png" alt="facebook"
                            />
                        </a>
                        <a
                            className="name" href={login_url}
                            xd-qa-type="link"
                            xd-qa-name="Login Instagram"
                        >
                            Instagram
                        </a>
                    </div>
                    {account.ig_account ? (
                        <div className="controls">
                            {igUnselected && (
                                SliderCheckbox({
                                    ...negateState(igUnselected),
                                    dark: true,
                                    xdQaName: "Instagram",
                                })
                            )}
                        </div>
                    ) : (
                        <div className="controls">
                            <a
                                className="connect"
                                href={login_url}
                                xd-qa-type="link"
                                xd-qa-name={"Connect Instagram"}
                            >
                                Connect
                            </a>
                            <span className="hint">
                                Sharing to Instagram requires an Instagram <a target="_blank" href="https://help.instagram.com/502981923235522">business account</a>
                            </span>
                        </div>
                    )}
                </div>
            </div>
        )}
    </>,
);

